import { Colors, extendTheme, ThemeComponents, ThemeConfig, withDefaultColorScheme, withDefaultSize } from "@chakra-ui/react";
import "@fontsource-variable/montserrat";

const fonts = {
  heading: `'Montserrat Variable', sans-serif`,
  body: `'Montserrat Variable', sans-serif`,
};
const colors: Colors = {
  gray: {
    700: "#1f2733",
  },
  main: "#29C0CE",
  google: {
    blue: "#4285F4",
    red: "#DB4437",
    green: "#0F9D58",
    yellow: "#F4B400",
  },
};
const fontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5625rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "2.5rem",
  "6xl": "3.75rem",
  "7xl": "4.375rem",
  "8xl": "5rem",
  "9xl": "5.625rem",
};
const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const styles = {
  global: (props: any) => ({
    body: {
      bg: `linear-gradient(to right, #010512 0%, #104D5A 46%, ${colors.main} 100%)`,
    },
    "*, *::before, ::after": {
      wordWrap: "normal",
    },
    "h1, h2, h3, h4, h5, h6, p, span": {
      color: "white",
    },
  }),
};

const components: ThemeComponents = {
  Text: {
    defaultProps: {
      size: "md",
    },
  },
  Badge: {
    sizes: {
      md: {
        width: "65px",
        height: "25px",
      },
    },
    baseStyle: {
      textTransform: "capitalize",
    },
  },
  Button: {
    baseStyle: {
      ".css-xl71ch": {
        flex: "unset",
      },
      ".css-1hzyiq5": {
        color: "#fff",
      },
    },
  },
};

const sizes = {
  container: {
    xl: "1350px",
  },
};
export const uiTheme = extendTheme(
  { colors, config, components, fonts, sizes, fontSizes, styles },
  withDefaultColorScheme({ colorScheme: "harry" }),
  withDefaultSize({ size: "lg" })
);
